'use strict';

export default class SettingsController {
  user = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  errors = {
    other: undefined
  };
  message = '';
  submitted = false;


  /*@ngInject*/
  constructor($scope, $timeout, Auth, appConfig, Modal, $localStorage, TranslationManager) {
    let $ctrl = this;
    this.Auth = Auth;
    this.TranslationManager = TranslationManager;
    this.appConfig = appConfig;
    this.Modal = Modal;
    this.$localStorage = $localStorage;
    this.storageReset = false;
    this.calibrated = $localStorage.calibrated || false;
    this.monitorSize = '??';
    if($localStorage.hasOwnProperty('screen')) {
      this.monitorSize = $localStorage.screen.actualHypotenuse / 25.4;
    }
    let screenChangeListener = $scope.$on('ts:screenChanged', () => {
      // We are using a different screen, alert the user their
      // screen may be no longer calibrated.
      $ctrl.calibrated = false;
      $timeout(() => {
        $scope.$apply();
      });
    });
    let calibrateListener = $scope.$on('ts:screenCalibrated', () => {
      console.log('calibrated!');
      $ctrl.calibrated = true;
      $timeout(() => {
        $scope.$apply();
      });
    });

    let destroyListener = $scope.$on('$destroy', () => {
      // clean house
      screenChangeListener();
      calibrateListener();
      destroyListener();
    });
  }

  startCalibration() {
    this.Modal.custom.calibrationWizard().then(() => {
      this.monitorSize = this.$localStorage.screen.actualHypotenuse / 25.4;
    }, _.noop);
  }

  confirmClearCache() {
    let $ctrl = this;
    // NOTE: cache clear warning modal content to have these four obj properties only as the same properties with similar names are accessed and used in the modal directive
    const cacheClearWarningModalContents = {
      // sending the text through translate so it can be embeded inside our warning modal after being tranlated
      heading: $ctrl.TranslationManager.getReference('calibration.modal.clearCacheModal.HEADING'),
      body: $ctrl.TranslationManager.getReference('calibration.modal.clearCacheModal.MODAL_BODY'),
      confirmText: $ctrl.TranslationManager.getReference('calibration.modal.clearCacheModal.CONFIRM_TEXT'),
      denyText: $ctrl.TranslationManager.getReference('calibration.modal.clearCacheModal.DENY_TEXT')
    };

    this.Modal.confirm.custom('danger', () => {
      // Clear the cache, user is sure
      $ctrl.$localStorage.$reset();
      $ctrl.storageReset = true;
    })(cacheClearWarningModalContents);
  }

  changePassword(form) {
    this.submitted = true;
    if(form.$valid) {
      this.Auth.changePassword(this.user.oldPassword, this.user.newPassword)
        .then(() => {
          this.message = this.appConfig.user.PASSWORD_CHANGE;
        })
        .catch(() => {
          form.password.$setValidity('mongoose', false);
          this.errors.other = this.appConfig.user.errors.PASSWORD_ERROR;
          this.message = '';
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/settings/settings.controller.js